import { __read, __spreadArray } from "tslib";
import { useMemo } from 'react';
export var DOTS = '...';
var range = function (start, end) {
    return __spreadArray([], __read(Array(end - start + 1)), false).map(function (_, i) { return start + i; });
};
export var usePagination = function (_a) {
    var totalCount = _a.totalCount, pageSize = _a.pageSize, _b = _a.siblingCount, siblingCount = _b === void 0 ? 1 : _b, currentPage = _a.currentPage;
    return useMemo(function () {
        var totalPageCount = Math.ceil(totalCount / pageSize);
        var totalPageNumbers = siblingCount + 6;
        if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
        }
        var leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
        var rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
        var shouldShowLeftDots = leftSiblingIndex > 3;
        var shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
        var firstPageIndex = 1;
        var lastPageIndex = totalPageCount;
        if (!shouldShowLeftDots && shouldShowRightDots) {
            var leftItemCount = 3 + 2 * siblingCount;
            var leftRange = range(1, leftItemCount);
            return __spreadArray(__spreadArray([], __read(leftRange), false), [DOTS, totalPageCount], false);
        }
        if (shouldShowLeftDots && !shouldShowRightDots) {
            var rightItemCount = 3 + 2 * siblingCount;
            var rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
            return __spreadArray([firstPageIndex, DOTS], __read(rightRange), false);
        }
        if (shouldShowLeftDots && shouldShowRightDots) {
            var middleRange = range(leftSiblingIndex, rightSiblingIndex);
            return __spreadArray(__spreadArray([firstPageIndex, DOTS], __read(middleRange), false), [DOTS, lastPageIndex], false);
        }
        return [];
    }, [totalCount, pageSize, siblingCount, currentPage]);
};
